import { render, staticRenderFns } from "./PvLogList.vue?vue&type=template&id=2b896803&"
import script from "./PvLogList.vue?vue&type=script&lang=ts&"
export * from "./PvLogList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports